<template>
  <div>
    <p class="no-margin">Créé {{value.createdAt | ago}}</p>
    <p class="no-margin text-size-small text-muted">Modifié {{value.updatedAt | ago}}</p>
  </div>
</template>

<script>
export default {
  props: {
    value: Object
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Activity.vue